import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { setLenis } from "@/lib/lenis";
import { FINISHES } from "@/data/finishes";
import Header from "@/components/portfolio/Header";
import Hero from "@/components/portfolio/Hero";
import Marquee from "@/components/portfolio/Marquee";
import FinishIndex from "@/components/portfolio/FinishIndex";
import FinishChapter from "@/components/portfolio/FinishChapter";
import SpecsBand from "@/components/portfolio/SpecsBand";
import Footer from "@/components/portfolio/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App font-sans">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <FinishIndex chapters={FINISHES} />
        {FINISHES.map((c, i) => (
          <FinishChapter key={c.id} chapter={c} index={i} />
        ))}
        <SpecsBand />
      </main>
      <Footer />
    </div>
  );
}

export default App;
